<template>
    <div v-loading="process.loading">
        <div class="freebusy">
            <div class="bf-header">
                <div class="header">
                    {{chineseDate}}
                </div>
                <div class="cell">
                    <el-button circle icon="el-icon-arrow-left" size="mini" @click="decrease"></el-button>
                    <el-button circle icon="el-icon-arrow-right" size="mini" @click="increase"></el-button>
                </div>
                <div class="cell" v-if="option_h323==='1'">
                    h323设备
                </div>
            </div>
            <div class="bf-table" ref="bf_table">
                <div class="bf-body">
                    <div class="header" v-for="hour in hourHeader" :key="hour">
                        {{hour}}
                    </div>
                </div>
                <div class="bf-body">
                    <div class="cell" v-for="(state,key) in states " :key="key" :class="{'free':state==='空','busy':state!=='空','occupy':occupy(key)}"
                         @click="selectDate(key,state)">
                        {{newState(state,key)}}
                    </div>
                </div>
                <div class="bf-body" v-if="option_h323==='1'">
                    <div class="cell" v-for="(state,key) in state_h323 " :key="key" :class="state==='空'?'free':'busy'"
                         @click="selectDate(key,state)">
                        {{newState(state)}}
                    </div>
                </div>
            </div>

        </div>
        <div style="line-height:normal;" class="text-secondary mt-1" :style="size==='small'?'font-size: 12px':''">
            <span style="font-size:95%;"><span style="padding:0 5px;color:#259b24;background-color: #EBF1E3">可用</span> 代表可申请，
                <span style="color:#101010;background-color: lightgray;padding: 0 5px;">&nbsp;&nbsp;&nbsp;&nbsp;</span> 代表不可申请。
                <span style="color:white;background-color: #9fcae7;padding: 0 5px;">可用</span>
                <span style="color:#000;background-color: #4d82a8;padding: 0 5px;">冲突</span> 代表选中情况
            </span>
        </div>
    </div>
</template>

<script>
    import {mapState} from "vuex";

    export default {
        name: "meeting-freebusy",
        data() {
            return {
                states: {},
                state_h323: {},
                headers: [],
                start_date: this.date,
                option_h323: this.h323,
                group_id:0,
                debounced:null,
            }
        },
        props: {
            date: {
                type: String,
                default() {
                    return new Date().Format('yyyy-MM-dd');
                }
            },
            time:{
                type: String,
                default() {
                    let d = new Date();
                    d.setMinutes(Math.floor(d.getMinutes()/30)*30);
                    return d.Format('hh:mm');
                }
            },
            duration:{
                type: Number,
                default() {
                    return 30;
                }
            },
            id: {
                type: Number,
                default() {
                    return 0;
                }
            },
            h323: {
                type: String,
                default() {
                    return '0';
                }
            },
            jump: {
                type: Boolean,
                default() {
                    return true;
                }
            },
            size:{
                type: String,
                default() {
                    return 'Medium';
                }
            },
            group:{
                type: Number,
                default() {
                    return 0;
                }
            }
        },
        watch: {
            date: {
                handler(val) {
                    if (this.validateDate(val)) {
                        this.start_date = val;
                        this.queryBF();
                    }
                },
                immediate:true,
            },
            duration: {
                handler() {
                    this.queryBF();
                },
                immediate:true,
            },
            h323: {
                handler(val) {
                    this.option_h323 = val;
                    this.queryBF();
                },
                immediate:true,
            },
            group: {
                handler(val) {
                    this.group_id = val;
                    this.queryBF();
                },
                immediate:true,
            },

        },
        computed: {
            ...mapState(['process']),
            chineseDate() {
                const d = this.start_date.split('-');
                return d[1] + '月' + d[2] + '日';
            },
            hourHeader() {
                return this.headers.filter((h, i) => {
                    return (i % 2 === 0)
                });
            },
        },
        methods: {
            validateDate(v) {
                const reg = /^\d{4}-\d{2}-\d{2}$/ig;
                return (reg.test(v));
            },
            newState(val,key) {
                if (val === '空') return '可用';
                if (this.occupy(key)) return '冲突';
                return '';
            },
            decrease() {
                let start = new Date(this.start_date.replace(/-/g, '/'));
                start.setDate(start.getDate() - 1);
                this.start_date = start.Format('yyyy-MM-dd');
                this.queryBF();
            },
            increase() {
                let start = new Date(this.start_date.replace(/-/g, '/'));
                start.setDate(start.getDate() + 1);
                this.start_date = start.Format('yyyy-MM-dd');
                this.queryBF();
            },
            queryBF() {
                if (this.debounced) this.debounced();
            },
            selectDate(key, state) {
                if (!this.jump) return;
                const vm = this;
                if (state === '空') {
                    const d = this.start_date.split('-');
                    const chinese = d[0] + '年' + d[1] + '月' + d[2] + '日';
                    this.$affirm('是否选择 ' + chinese + ' ' + key + ' 为会议起始时间?').then(function () {
                        let ret = {date: vm.start_date, time: key};
                        vm.$emit('change', ret);
                    }).catch(() => {
                    });
                }
            },
            occupy(time){
                if (this.$organization.no_indicate) return false;
                let start = parseInt(this.time.substr(0,2) ) * 60 + parseInt(this.time.substr(-2));
                let end = start + this.duration;
                const minutes = parseInt(time.substr(0,2) ) * 60 + parseInt(time.substr(-2));
                //console.log('time',time,start,end,this.time,minutes)

                return minutes >=start && minutes<end;
            }
        },
        created() {
            const vm = this;
            if (!this.debounced) {
                this.debounced = this.$debounce(200,false,function () {
                    if (vm.group_id === 0) return;
                    vm.$api('Query.Busy', {
                        start_date: vm.start_date,
                        id: vm.id,
                        duration:vm.duration,
                        h323: vm.option_h323 === '1',
                        group_id:vm.group_id,
                    }, false).then(res => {
                        if (res.data.success) {
                            vm.$set(vm,'states',res.data.data.states);
                            vm.headers = res.data.data.headers;
                            vm.state_h323 = res.data.data.h323;
                            this.$nextTick(function () {
                                if (vm.$refs['bf_table']) {
                                    const now = new Date();
                                    if (vm.start_date === now.Format('yyyy-MM-dd')) {
                                        const hour = now.getHours();
                                        vm.$refs['bf_table'].scrollTo(74*hour, 0);
                                    } else {
                                        vm.$refs['bf_table'].scrollTo(74*6, 0);
                                    }
                                }
                            });
                        }
                    })
                })
            }
        },
        mounted() {
            const vm=this;
            vm.queryBF();
        }
    }
</script>

<style lang="scss">

    $cell-width: 74px;
    $cell-height: 41px;
    $header-height: 32px;

    .freebusy {
        width: 100%;
        overflow: hidden;
        position: relative;
        border: 1px solid #BBBBBB;
        min-height: $cell-height + $header-height + 2px;
        background-color: #7a868c;

        .bf-header {
            position: absolute;
            left: 0;
            top: 0;
            z-index: 1;

            .header {
                height: $header-height;
                width: $cell-width;
                background-color: #7a868c;
                color: white;
                text-align: center;
                line-height: $header-height;
                font-weight: 400;
                border-right: 1px solid #bbbbbb;
                box-sizing: border-box;
            }

            .cell {
                height: $cell-height;
                width: $cell-width;
                line-height: $cell-height - 5px;
                background-color: white;
                color: #101010;
                text-align: center;
                box-sizing: border-box;
                border-right: 1px solid #bbbbbb;
                border-bottom: 1px solid #bbb;
            }
        }

        .bf-table {
            width: 100%;
            overflow-x: auto;
            overflow-y: hidden;

            .bf-body {
                width: $cell-width*25;
                padding-left: $cell-width;

                .header {
                    height: $header-height;
                    width: $cell-width;
                    float: left;
                    background-color: #9e9e9e;
                    color: white;
                    text-align: center;
                    line-height: 32px;
                    font-weight: 400;
                    border-left: 1px solid #bbbbbb;
                    box-sizing: border-box;
                }

                .cell {
                    height: $cell-height;
                    width: $cell-width/2;
                    line-height: $cell-height - 5px;
                    background-color: white;
                    color: #101010;
                    text-align: center;
                    box-sizing: border-box;
                    border-left: 1px solid #bbbbbb;
                    float: left;
                    border-bottom: 1px solid #bbb;


                    &.busy {
                        color: #101010;
                        background-color: #C8C8C8;
                    }

                    &.free {
                        color: #259b24;
                        background-color: #EBF1E3;
                        cursor: pointer;
                    }
                    &.free.occupy {
                        color:white;
                        background-color: #9fcae7;
                        cursor: pointer;
                    }
                    &.busy.occupy{
                        background-color: #4d82a8;
                    }
                }
            }
        }
    }
</style>
